import { useEffect, useState } from 'react';

/**
 * Tracks whether the given media query currently matches. Re-renders on
 * change so consumers can swap layouts/widths between breakpoints
 * without polling window.innerWidth manually.
 */
const useMediaQuery = (query: string): boolean => {
  const getMatch = (): boolean =>
    typeof window !== 'undefined' && window.matchMedia(query).matches;

  const [matches, setMatches] = useState<boolean>(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(query);
    const handle = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', handle);
    return () => mql.removeEventListener('change', handle);
  }, [query]);

  return matches;
};

export default useMediaQuery;
